import { useEffect } from 'react';
import { useAuth } from '../../components/features/auth/AuthGuard';
import AppraisalList from '../../components/features/performance/AppraisalList';
import { PERMISSIONS } from '../../constants';
import { Box, Alert } from '@mui/material';

const PendingReviewsPage = () => {
  const { hasPermission } = useAuth();

  // Check if user has permission to view pending reviews
  if (!hasPermission(PERMISSIONS.PERFORMANCE_REVIEW)) {
    return (
      <Box p={3}>
        <Alert severity="error">
          You don't have permission to view pending reviews.
        </Alert>
      </Box>
    );
  }

  return (
    <Box p={3}>
      <AppraisalList 
        type="pending"
        title="Appraisals Pending Review"
      />
    </Box>
  );
};

export default PendingReviewsPage;
